import { render, staticRenderFns } from "./RequestAccess.vue?vue&type=template&id=3cf577b0"
import script from "./RequestAccess.vue?vue&type=script&lang=ts"
export * from "./RequestAccess.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports